import type { ContactDedupComponentProps } from './ContactDedupComponent';

export const ContactDedupComponent = {
    MountAsync: async (target: HTMLElement, props: ContactDedupComponentProps) => {
        const { mountReactComponentAsync } = await import('../../../js/mountReactComponentAsync');
        const { ContactDedupComponent } = await import('./ContactDedupComponent');
        return await mountReactComponentAsync(target, ContactDedupComponent, props);
    }
};
